import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { Questions, SelectedOptionList, Rules } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { PreviewData } from 'src/app/common-class/survey';
import { Group } from 'src/app/common-class/pages';
// import { threadId } from 'worker_threads';

@Component({
  selector: 'app-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckBoxComponent implements OnInit {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() isMobile: boolean;
  @Input() isGrid: boolean;
  @Input() isNewParticipationButton: boolean;
  @Input() isStandAlone: boolean;
  @Input() group: Group;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions;
  answerImagesLength: number;
  answerLength: number;
  columnWidth: any;

  public tempArray = [];
  public answersArray: any;
  public answersArray1: any;

  selectedValueList: SelectedOptionList[] = [];

  singleImageArray: Array<number> = [];
  multiImageArray: Array<number> = [];
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean;
  isAriaRequired: boolean = false;
  isCapchaManditorySkip: boolean;
  nextButtonClickNo: number;
  pageIsSoftRequiredHandle: any;
  nextButtonClickSub: any;
  surveyFormat: number;
  isNewParticipation: boolean;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean;
  resetPageSub: any;
  isDisplayedPipeMessage: boolean;
  AsteriskMandatory: string = '';
  isEditPostPop: boolean = false;

  // Add property to store event listener references
  private eventListeners: Map<string, (event: Event) => void> = new Map();

  ngOnChanges(changes: SimpleChanges) {
    let change = changes['JsonData'];

    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
      this.answerPipingMessageDisplayed();

      if (
        this.questions.answer_style == 1 &&
        this.questions.RotateIndex == 0 &&
        this.questions.Answers != null
      ) {
        this.RandomAnswerHandling();
      }

      if (this.questions.selectedOptionList != null) {
        this.selectedValueList = this.questions.selectedOptionList;
        this.isAnsChange = true;
      } else {
        this.selectedValueList = [];
      }

      if (
        (this.questions.qsubtype == 1 || this.questions.DispAnsCol > 1) &&
        !(this.questions.population_type == 3 || this.questions.population_type == 2)
      ) {
        let id = 'div_Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_ID';
        const parentElement = document.getElementById(id);

        if (parentElement) {
          const checkboxes = parentElement.querySelectorAll('input[type="checkbox"]');
          checkboxes.forEach((checkbox) => {
            (checkbox as HTMLInputElement).checked = false;
          });

          const selectedElements = parentElement.querySelectorAll('.selectedAnsOpt');
          selectedElements.forEach((element) => {
            element.classList.remove('selectedAnsOpt');
          });
        }

        if (
          (this.questions.DispAnsCol > 1 || this.questions.qtype == 'HR') &&
          this.questions.Answers != null
        ) {
          this.HorizontalAndVerticalHandling();
        }
        this.ngAfterViewInit();
      }
    }
  }

  constructor(
    private service: ParticipationDataService,
    private changeDetect: ChangeDetectorRef,
    private previewData: PreviewData,
  ) {}

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);
      this.isEditPostPop = this.service.getisEditPostPop();

      this.answerPipingMessageDisplayed();
      this.AsteriskMandatory = this.service.getSurveyMessages()?.AsteriskMandatory;
      let updateItem = this.questions?.Answers.find(
        (e) =>
          (e.hasImage && e.AnswerImages.length == 2) ||
          (e.hasMedia && e.AnswerMedias.length == 2) ||
          (e.hasImage && e.AnswerImages.length == 1 && e.hasMedia && e.AnswerMedias.length == 1),
      );

      if (updateItem != null && updateItem != undefined) {
        this.answerImagesLength = 2;

        if (this.questions.population_type == 3) {
          if (this.questions.selectAnsValue != updateItem.value_id) {
            this.answerImagesLength = 0;
          }
        }
      } else {
        updateItem = this.questions?.Answers.find(
          (e) =>
            (e.hasImage && e.AnswerImages.length == 1) ||
            (e.hasMedia && e.AnswerMedias.length == 1),
        );

        if (updateItem != null && updateItem != undefined) {
          this.answerImagesLength = 1;

          if (this.questions.population_type == 3) {
            if (this.questions.selectAnsValue != updateItem.value_id) {
              this.answerImagesLength = 0;
            }
          }
        }
      }

      var hiddenAnswers = this.questions?.Answers.filter(
        (e) => e.isHide == false && e.isQuotaHide == false,
      );
      if (
        hiddenAnswers?.length > 0 &&
        this.questions?.qtype == 'C' &&
        this.questions?.qsubtype == 1
      ) {
        this.questions.Answers = hiddenAnswers;
      }

      if (this.questions?.population_type == 3) {
        if (
          (this.questions.DispAnsCol > 1 || this.questions.qtype == 'HR') &&
          this.questions.Answers != null
        ) {
          this.questions.Answers = this.questions.Answers.filter((e) =>
            this.CheckInSelectedAnsertList(e.value_id),
          );
        }
        this.answerLength = this.questions.Answers.filter(
          (e) => e.isHide == false && e.isADLHide == false && e.ControlAns == true,
        ).length;
      } else {
        this.answerLength = this.questions?.Answers.filter(
          (e) => e.isHide == false && e.isADLHide == false,
        ).length;
      }

      if (
        this.questions?.answer_style == 1 &&
        this.questions?.RotateIndex == 0 &&
        this.questions?.Answers != null
      ) {
        this.RandomAnswerHandling();
      }

      if (
        (this.questions?.DispAnsCol > 1 || this.questions?.qtype == 'HR') &&
        this.questions?.Answers != null
      ) {
        this.HorizontalAndVerticalHandling();
      }

      if (this.questions?.selectedOptionList != null) {
        this.selectedValueList = this.questions.selectedOptionList;
        this.isAnsChange = true;
      }

      // Set ControlAns property for edit response scenario
      if (this.questions.selectedOptionList && this.questions.selectedOptionList.length > 0) {
        this.questions.Answers.forEach((answer) => {
          const isSelected = this.questions.selectedOptionList.some(
            (selected) => selected.value_id === answer.value_id,
          );
          if (isSelected) {
            answer.ControlAns = true;
            answer.selectdId = 1;
          } else {
            answer.ControlAns = false;
            answer.selectdId = 0;
          }
        });

        // Trigger change detection to update the UI
        this.changeDetect.detectChanges();
      }
    }

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    if (this.questions?.qtype == 'ML') {
      this.answerImagesLength = 0;
    }

    this.isPreview = this.service.GroupType?.toUpperCase() == 'PREVIEW';

    this.surveyFormat = this.service.surveyFormat;
    this.isNewParticipation = this.service.isNewParticipation;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    //this.showNewParticipationButton = this.questions.isMatrixQuestion ==undefined && this.isNewParticipationButton;
    this.showNewParticipationButton = this.isNewParticipationButton;
    this.isAriaRequired =
      (this.questions?.mandatory && this.isMandatoryUpfront) ||
      (this.questions?.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);
  }

  ngAfterViewInit() {
    if (window.navigator.userAgent.indexOf('Chrome') != -1) {
      const answerParentElements = document.querySelectorAll(
        '.answerParent',
      ) as NodeListOf<HTMLElement>;
      answerParentElements.forEach((element) => {
        element.style.width = 'calc(100% + 1px)';
      });
    }

    setTimeout(() => {
      const imageChoiceWrappers = document.querySelectorAll(
        '.image-choice-wrapper',
      ) as NodeListOf<HTMLElement>;
      imageChoiceWrappers.forEach((wrapper) => {
        const icLabel = wrapper.querySelector('.ic-label') as HTMLElement;
        const icImageHolders = wrapper.querySelectorAll(
          '.ic-image-holder',
        ) as NodeListOf<HTMLElement>;

        icImageHolders.forEach((icImageHolder) => {
          if (icLabel?.classList.contains('medium')) {
            icImageHolder.classList.add('medium');
          } else if (icLabel?.classList.contains('small')) {
            icImageHolder.classList.add('small');
          } else {
            icImageHolder.classList.add('large');
          }
        });

        const imageHolders = wrapper.querySelectorAll(
          '.ic-image-holder',
        ) as NodeListOf<HTMLElement>;
        const visibleImageHolders = Array.from(imageHolders).filter(
          (holder) =>
            holder.offsetParent !== null && holder.offsetWidth > 0 && holder.offsetHeight > 0,
        );
        visibleImageHolders.forEach((holder) => {
          const elements = Array.from(holder.querySelectorAll('.ic-report-value')) as HTMLElement[];
          let reportValue: HTMLElement | null = null;

          for (const el of elements) {
            const style = window.getComputedStyle(el);

            const isVisible =
              el.offsetParent !== null && style.visibility !== 'hidden' && style.opacity !== '0';

            if (isVisible) {
              reportValue = el;
              break;
            }
          }

          if (reportValue) {
            holder.style.paddingBottom = `${reportValue.offsetHeight}px`;
          }
          holder.style.height = `${holder.offsetWidth}px`;
        });
      });
    }, 50);

    window.addEventListener('resize', () => {
      const imageHolders = document.querySelectorAll('.ic-image-holder') as NodeListOf<HTMLElement>;

      const visibleImageHolders = Array.from(imageHolders).filter(
        (holder) =>
          holder.offsetParent !== null && // Element is in layout (not display: none)
          holder.offsetWidth > 0 &&
          holder.offsetHeight > 0,
      );

      visibleImageHolders.forEach((holder) => {
        holder.style.height = `${holder.offsetWidth}px`; // Set height equal to width
      });
    });
    if (this.questions?.DispAnsCol > 1 && !this.isMobile) {
      // Add a small delay to ensure DOM is ready
      setTimeout(() => {
        for (let i = 0; i < this.questions.Answers.length; i++) {
          const id =
            'td_Q' +
            this.questions.qno +
            '_' +
            this.questions.UniqueNumber +
            '_' +
            this.questions.Answers[i].value_id;

          const element = document.getElementById(id);

          if (element) {
            // Remove existing event listener if it exists
            const existingListener = this.eventListeners.get(id);
            if (existingListener) {
              element.removeEventListener('click', existingListener);
            }

            // Create new event listener
            const newListener = (event: Event) => {
              event.stopPropagation();
              const target = event.currentTarget as HTMLElement;
              if (!target.classList.contains('hrb-disabled')) {
                this.checkboxSelection(this.questions.Answers[i]);
              }
            };

            // Store the listener reference and add it
            this.eventListeners.set(id, newListener);
            element.addEventListener('click', newListener);
          }
        }
      }, 50);
    }

    this.isAriaRequired =
      (this.questions?.mandatory && this.isMandatoryUpfront) ||
      (this.questions?.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);
    this.isCapchaManditorySkip = this.service.getIsCapchaMandatorySkip();
    this.pageIsSoftRequiredHandle = this.service.getPageIsSoftRequiredHandle();
    this.nextButtonClickNo =
      this.service.getNextButtonClickNo() == undefined ? 0 : this.service.getNextButtonClickNo();
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.isFormSubmitSub) {
      this.isFormSubmitSub.unsubscribe();
    }
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }

    // Clean up event listeners
    this.eventListeners.forEach((listener, id) => {
      const element = document.getElementById(id);
      if (element) {
        element.removeEventListener('click', listener);
      }
    });
    this.eventListeners.clear();
  }

  answerPipingMessageDisplayed() {
    if (
      this.previewData != undefined &&
      this.service.getPrevPgChnge() && //this.previewData.isPrevPgChnge &&
      this.questions.AnsPipeCondition != 0 &&
      this.questions.AnsPipeCondition != 1 &&
      this.questions.AnsPipeCondition != 3 &&
      this.questions.AnsPipeCondition != 4
    ) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }
    if (this.questions?.qtype == 'ML') {
      this.answerImagesLength = 0;
    }
  }

  SortValue(valueId: any, curVal, self) {
    let ans = self.questions.Answers.find((e) => e.value_id == valueId);

    if (ans != null && ans != undefined) {
      if (curVal) {
        ans.ControlAns = true;
      } else {
        ans.ControlAns = false;
      }

      this.SelectedValue(ans, curVal);
    }
  }

  RandomAnswerHandling() {
    let currentIndex = this.questions.Answers.length,
      temporaryValue,
      randomIndex;
    let updateItem = this.questions.Answers.find((e) => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      currentIndex -= 1;
    }

    let isNoneAbove = this.questions.Answers.find(
      (e) =>
        e.IsNoneAbove &&
        (e.ControlAns || this.questions.qtype == 'C' || this.questions.qtype == 'ML'),
    );

    if (isNoneAbove != null && isNoneAbove != undefined) {
      currentIndex -= 1;
    }

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = this.questions.Answers[currentIndex];
      this.questions.Answers[currentIndex] = this.questions.Answers[randomIndex];
      this.questions.Answers[randomIndex] = temporaryValue;
    }
  }

  HorizontalAndVerticalHandling() {
    let DispAnsCol = this.questions.qtype == 'HR' ? 4 : this.questions.DispAnsCol;

    let _isNoneAbove = false;

    let qShowAnswers = this.questions.Answers.filter((e) => e.isADLHide == false);

    _isNoneAbove = qShowAnswers.filter((e) => e.IsNoneAbove).length > 0;

    let answerLength = qShowAnswers.length;

    let updateItem = qShowAnswers.find((e) => e.isOther);

    if (updateItem != undefined && updateItem != null && _isNoneAbove) {
      answerLength -= 2;
    } else if ((updateItem != undefined && updateItem != null) || _isNoneAbove) {
      answerLength -= 1;
    }
    let rowCount = Math.ceil(answerLength / DispAnsCol);

    this.columnWidth = 100 / DispAnsCol;

    if (this.questions.DispAnsFormat == 1) {
      //Vertical
      let ansArray = [];
      let ansArray1 = [];

      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        let index = 0;

        for (let j = i; j < answerLength; j = j + rowCount) {
          tempArray.push(qShowAnswers[j]);

          if (qShowAnswers[j].hasImage || qShowAnswers[j].hasMedia) {
            this.SingleAndMultiImageHandling(index, j);
          }

          index++;
        }

        ansArray.push(tempArray);
      }

      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }
      if (_isNoneAbove) {
        ansArray1.push([qShowAnswers[qShowAnswers.length - 1]]);
      }
      this.answersArray = ansArray;
      this.answersArray1 = ansArray1;
      //this.tempArray[0] = ansArray;
    } else if (this.questions.DispAnsFormat == 2 || this.questions.qtype == 'HR') {
      //Horizontal
      let ansArray = [];
      let ansArray1 = [];

      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        let counter = 0;
        let index = 0;
        for (let j = i * DispAnsCol; j < answerLength; j++) {
          counter++;
          tempArray.push(qShowAnswers[j]);

          if (qShowAnswers[j].hasImage || qShowAnswers[j].hasMedia) {
            this.SingleAndMultiImageHandling(index, j);
          }
          index++;

          if (counter == DispAnsCol) {
            break;
          }
        }

        ansArray.push(tempArray);
      }

      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }
      if (_isNoneAbove) {
        ansArray1.push([qShowAnswers[qShowAnswers.length - 1]]);
      }

      //this.tempArray[0] = ansArray;
      this.answersArray = ansArray;
      this.answersArray1 = ansArray1;
    }

    //this.answersArray = this.tempArray;
  }

  SingleAndMultiImageHandling(index: number, j: number) {
    if (
      (this.questions.Answers[j].AnswerMedias != null &&
        this.questions.Answers[j].AnswerMedias.length > 1) ||
      (this.questions.Answers[j].AnswerImages != null &&
        this.questions.Answers[j].AnswerImages.length > 1) ||
      this.multiImageArray.indexOf(index) >= 0
    ) {
      if (this.multiImageArray.indexOf(index) < 0) {
        this.multiImageArray.push(index);
      }

      if (this.singleImageArray.indexOf(index) >= 0) {
        this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
      }
    } else if (
      this.questions.Answers[j].AnswerMedias != null &&
      this.questions.Answers[j].AnswerMedias.length == 1 &&
      this.questions.Answers[j].AnswerImages != null &&
      this.questions.Answers[j].AnswerImages.length == 1
    ) {
      if (this.multiImageArray.indexOf(index) < 0) {
        this.multiImageArray.push(index);
      }

      if (this.singleImageArray.indexOf(index) >= 0) {
        this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
      }
    } else {
      if (this.singleImageArray.indexOf(index) < 0) {
        this.singleImageArray.push(index);
      }
    }
  }

  HasSingleImageClass(index: number): boolean {
    if (this.singleImageArray.indexOf(index) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  HasMultiImageClass(index: number): boolean {
    if (this.multiImageArray.indexOf(index) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  GetMandatoryState(): boolean {
    if (this.questions != null) {
      return this.questions.mandatory;
    }
  }

  updateselectedValueList() {
    for (let i = 0; i < this.questions.Answers.length; i++) {
      if (this.questions.Answers[i].isADLHide) {
        this.RemoveSelectedList(this.questions.Answers[i]);
      }
    }
  }

  SelectedValue(answer: Answers, event: any) {
    this.questions.isAlertDanger = false;
    let updateItem = this.questions.Answers.find(this.findIndexToUpdate, answer);
    let index = this.questions.Answers.indexOf(updateItem);

    if (event) {
      this.AddSelectedValueList(answer);
      answer.selectdId = 1;
      answer.ControlAns = answer.value_text;
      this.questions.Answers[index] = answer;
      this.questions.pageto = answer.pageto;
      if (this.questions.IsADLRuleApplied) {
        this.updateselectedValueList();
      }
      this.questions.selectedOptionList = this.selectedValueList;

      if (this.questions.isSoftRequired) {
        this.questions.isSoftRequiredHandle = true;
      }

      if (this.questions.ansConstraint != null && this.questions.selectedOptionList.length > 0) {
        this.AnsConstraintHandling();
      } else {
        this.questions.isValid = false;
      }

      if (answer.IsNoneAbove) {
        for (let i = 0; i < this.questions.Answers.length; i++) {
          if (answer.value_id != this.questions.Answers[i].value_id) {
            this.questions.Answers[i].ControlAns = null;
            this.questions.Answers[i].selectdId = 0;
          }
        }
        this.questions.isOtherAnswer = false;
        this.questions.otherAnswer = null;
        this.questions.isValid = false;
        this.questions.isAlertDanger = false;
        this.selectedValueList = [];
        this.questions.selectedOptionList = this.selectedValueList;

        this.AddSelectedValueList(answer);
      } else {
        let isNoneAbove = this.questions.Answers.find((e) => e.IsNoneAbove && e.ControlAns);

        if (isNoneAbove != null && isNoneAbove != undefined) {
          let index = this.questions.Answers.indexOf(isNoneAbove);
          this.questions.Answers[index].ControlAns = null;
          this.questions.Answers[index].selectdId = 0;

          this.RemoveSelectedList(this.questions.Answers[index]);
          this.questions.selectedOptionList = this.selectedValueList;

          if (
            this.questions.ansConstraint != null &&
            this.questions.selectedOptionList.length > 0
          ) {
            this.AnsConstraintHandling();
          } else {
            this.questions.isValid = false;
          }
        }
      }

      if (answer.isOther) {
        this.questions.isOtherAnswer = true;
        let id = this.questions.UniqueNumber + '_txt_other';
        let control = document.getElementById(id);

        setTimeout(function () {
          control.focus();
        }, 0);
      }
    } else {
      this.RemoveSelectedList(answer);

      answer.selectdId = 0;
      answer.ControlAns = null;

      this.questions.selectedOptionList = this.selectedValueList;

      if (this.questions.ansConstraint != null && this.questions.selectedOptionList.length > 0) {
        this.AnsConstraintHandling();
      } else {
        this.questions.isValid = false;
      }

      if (answer.IsNoneAbove) {
        this.questions.isValid = false;
      }

      this.questions.Answers[index] = answer;
      this.questions.AnswerID = 0;
      this.questions.selectAnsValue = 0;

      if (
        this.questions.selectedOptionList != null &&
        this.questions.selectedOptionList.length == 0
      ) {
        this.questions.pageto = 0;
      }

      if (this.questions.isSoftRequired) {
        this.questions.isSoftRequiredHandle = false;
      }

      if (answer.isOther) {
        this.questions.isOtherAnswer = false;
        this.questions.otherAnswer = null;
      }
    }

    if (this.selectedValueList.length > 0) {
      this.questions.AnswerText = 'Selected Answer Option';
    } else {
      this.questions.AnswerText = null;
    }
    this.changeDetect.detectChanges();
    this.service.setQuestionChange(this.questions);
    this.ChangeAnswersData.emit(this.questions);
    this.isAnsChange = true;
  }

  AddSelectedValueList(answer: Answers) {
    let selectedList = this.selectedValueList.find((e) => e.value_id == answer.value_id);

    if (this.selectedValueList.indexOf(selectedList) < 0) {
      this.selectedValueList.push({
        value_id: answer.value_id,
        value_text: answer.value_text,
        isOther: answer.isOther,
      });
    }
  }

  RemoveSelectedList(answer: Answers) {
    let selectedList = this.selectedValueList.find((e) => e.value_id == answer.value_id);

    let curIndex = this.selectedValueList.indexOf(selectedList);

    if (curIndex >= 0) {
      this.selectedValueList.splice(curIndex, 1);
    }
  }

  AnsConstraintHandling() {
    let ansCons = this.questions.ansConstraint.split(' ');

    if (ansCons[0] == '=') {
      if (this.questions.selectedOptionList.length == parseInt(ansCons[1])) {
        this.questions.isValid = false;
        this.questions.isAlertDanger = false;
      } else {
        this.questions.isValid = true;
        this.questions.isAlertDanger = true;
      }
    } else if (ansCons[0] == '>=') {
      if (this.questions.selectedOptionList.length >= parseInt(ansCons[1])) {
        this.questions.isValid = false;
        this.questions.isAlertDanger = false;
      } else {
        this.questions.isValid = true;
        this.questions.isAlertDanger = true;
      }
    } else if (ansCons[0] == '<=') {
      if (this.questions.selectedOptionList.length <= parseInt(ansCons[1])) {
        this.questions.isValid = false;
        this.questions.isAlertDanger = false;
      } else {
        this.questions.isValid = true;
        this.questions.isAlertDanger = true;
      }
    }
  }

  findIndexToUpdate(answer) {
    return answer === this;
  }

  GetQuestionsString(question: Questions, index: number): string {
    return JSON.stringify(question);
  }

  UpdateQuestionsData(question: Questions) {
    this.ChangeAnswersData.emit(question);
    this.isAnsChange = true;
  }

  checkInput(event: Event) {
    const target = event.target as HTMLElement;
    const inputElement = target.querySelector('input') as HTMLInputElement;

    if (inputElement) {
      if (!inputElement.checked) {
        if (inputElement.type === 'radio') {
          const parentWrapper = target.closest('.image-choice-wrapper') as HTMLElement;
          if (parentWrapper) {
            const radioInputs = parentWrapper.querySelectorAll(
              'input',
            ) as NodeListOf<HTMLInputElement>;
            radioInputs.forEach((radio) => {
              radio.checked = false;
            });
          }
        }
        inputElement.checked = true;
      } else {
        inputElement.checked = false;
      }

      const val = inputElement.getAttribute('ng-reflect-value');
      console.log(val);
    }
  }

  getAnsImageMediaCSS(answer: Answers) {
    if (
      (answer.hasImage == true && answer.AnswerImages.length == 1 && answer.hasMedia == false) ||
      (answer.hasMedia == true && answer.AnswerMedias.length == 1 && answer.hasImage == false)
    ) {
      return 'single-ans-image';
    } else if (
      answer.hasImage == true &&
      answer.AnswerImages.length == 1 &&
      answer.hasMedia == true &&
      answer.AnswerMedias.length == 1
    ) {
      return 'multi-ans-image';
    } else if (
      (answer.hasImage == true && answer.AnswerImages.length == 2) ||
      (answer.hasMedia == true && answer.AnswerMedias.length == 2)
    ) {
      return 'multi-ans-image';
    }
  }

  onBlurMethod() {
    if (this.questions.AnswerText == '') {
      this.questions.AnswerText = null;
    }
    this.service.setQuestionChange(this.questions);
    this.ChangeAnswersData.emit(this.questions);
    this.isAnsChange = true;
  }

  loadInlineQDL(rule_Id: number): Questions {
    if (this.questions.rules != null && this.questions.rules.length > 0) {
      this.nextButtonClickNo = this.service.getNextButtonClickNo();
      let updateItem = this.questions.rules.filter((e) => e.Rule_id == rule_Id && e.InlineQDL);

      if (updateItem != null && updateItem != undefined) {
        return this.newInlineQDLHandling(updateItem);
      }
    }

    return null;
  }

  newInlineQDLHandling(rule: Rules[]): Questions {
    for (let k = 0; k < rule.length; k++) {
      let value = rule[k].ConditionValue.split(',');

      if (value != undefined && value != null) {
        let count: number = 0;
        for (let i = 0; i < value.length; i++) {
          if (
            this.questions.selectedOptionList != null &&
            this.questions.selectedOptionList.indexOf(
              this.questions.selectedOptionList.find((e) => e.value_id == parseInt(value[i])),
            ) >= 0
          ) {
            count++;
          }
        }

        if (this.newOperatorValid(rule[k], count, value) != null) {
          return this.newOperatorValid(rule[k], count, value);
        }
      }
    }
  }

  newOperatorValid(updateItem: Rules, count: number, value: any): Questions {
    if (updateItem.Operator == 'AND' && count == value.length) {
      return this.newLoadQDL(updateItem);
    } else if (updateItem.Operator == 'OR' && count <= value.length && count != 0) {
      return this.newLoadQDL(updateItem);
    } else if (updateItem.Operator == 'NOT' && count == 0) {
      return this.newLoadQDL(updateItem);
    } else if (updateItem.Operator == 'ISANSWERED' && this.questions.selectedOptionList != null) {
      return this.newLoadQDL(updateItem);
    } else if (
      updateItem.Operator == 'ISNOTANSWERED' &&
      (this.questions.selectedOptionList == null || this.questions.selectedOptionList.length == 0)
    ) {
      return this.newLoadQDL(updateItem);
    } else {
      return null;
    }
  }

  newLoadQDL(updateItem: Rules): Questions {
    let qn = this.service.GetQDL(updateItem.ConditionQID);

    if (qn != undefined && qn != null) {
      if (!qn.isLoading) {
        qn.isLoading = true;
        this.ChangeLoadingAnswersData.emit(qn);
      }
    }
    return this.service.GetQDL(updateItem.ConditionQID);
  }

  loadDestinationQn(rule_Id: number): Questions {
    if (
      this.questions.DestinationQuestions != null &&
      this.questions.DestinationQuestions != undefined
    ) {
      if (this.questions.DestinationQuestions.find((e) => e.rule_id == rule_Id) != undefined) {
        let qn = this.service.GetQDL(
          this.questions.DestinationQuestions.find((e) => e.rule_id == rule_Id).ConditionQID,
        );

        if (qn != undefined && qn != null) {
          if (!qn.isLoading) {
            qn.isLoading = true;
            this.ChangeLoadingAnswersData.emit(qn);
          }
        }

        return this.service.GetQDL(
          this.questions.DestinationQuestions.find((e) => e.rule_id == rule_Id).ConditionQID,
        );
      } else {
        return null;
      }
    }
  }

  gotoNextQuestion(question: Questions, event: any) {
    if (this.isStandAlone) {
      // Get the number of next inactive questions with `.question-data`
      const activeQuestion = event.closest('.active-ques') as HTMLElement;
      const nextInactiveQuestions = Array.from(
        activeQuestion?.parentElement?.querySelectorAll('.inactive-ques') || [],
      ).filter((el) => el.querySelector('.question-data'));
      const nextbtnLength = nextInactiveQuestions.length;

      let scrollTargetElement = document.getElementById('bodyScroll') as HTMLElement;
      const checkIfPreview = this.service.preview && this.service.preview.viewport;

      let elemPosition: number | null = null;
      const currentElementMtrx = event.closest(
        '.matrix-standalone-active-ques' + question.group_no,
      ) as HTMLElement;
      if (currentElementMtrx) {
        const allSiblingsMtrx = Array.from(
          currentElementMtrx.parentElement?.children || [],
        ) as HTMLElement[];
        const nextElementsMtrx = allSiblingsMtrx
          .slice(allSiblingsMtrx.indexOf(currentElementMtrx) + 1)
          .filter((sibling) =>
            sibling.matches('.matrix-standalone-active-ques' + question.group_no),
          );
        if (nextElementsMtrx.length > 0) {
          elemPosition = nextElementsMtrx[0].getBoundingClientRect().top;
        }
      }
      let MatrixelemPosition: number | null = null;
      let MatrixelemPosition1: number | null = null;

      if (this.questions.isMatrixQuestion != undefined) {
        // Handle `.matrix-mobile-subQ_`
        let matrixCurrentElementM = event.closest(
          '.matrix-mobile-subQ_' + this.group.Matrix_id,
        ) as HTMLElement;
        if (matrixCurrentElementM) {
          const allSiblingsM = Array.from(
            matrixCurrentElementM.parentElement?.children || [],
          ) as HTMLElement[];
          const nextMatrixElementsM = allSiblingsM
            .slice(allSiblingsM.indexOf(matrixCurrentElementM) + 1)
            .filter((sibling) => sibling.matches('.matrix-mobile-subQ_' + this.group.Matrix_id));
          if (nextMatrixElementsM.length > 0) {
            MatrixelemPosition = nextMatrixElementsM[0].getBoundingClientRect().top;
          }
        }

        // Handle `.matrix-mobile-subQ-cont`
        let matrixContCurrentElementM1 = event.closest('.matrix-mobile-subQ-cont') as HTMLElement;
        if (matrixContCurrentElementM1) {
          const allSiblingsM1 = Array.from(
            matrixContCurrentElementM1.parentElement?.children || [],
          ) as HTMLElement[];
          const nextMatrixContElementsM1 = allSiblingsM1
            .slice(allSiblingsM1.indexOf(matrixContCurrentElementM1) + 1)
            .filter((sibling) => sibling.matches('.matrix-mobile-subQ-cont'));
          if (nextMatrixContElementsM1.length > 0) {
            MatrixelemPosition1 = nextMatrixContElementsM1[0].getBoundingClientRect().top;
          }
        }
      }

      if (elemPosition !== null) {
        let currentElementMSAQ = event.closest(
          '.matrix-standalone-active-ques' + question.group_no,
        ) as HTMLElement;
        if (currentElementMSAQ) {
          const allSiblingsMSAQ = Array.from(
            currentElementMSAQ.parentElement?.children || [],
          ) as HTMLElement[];
          const nextElementsMSAQ = allSiblingsMSAQ
            .slice(allSiblingsMSAQ.indexOf(currentElementMSAQ) + 1)
            .filter((sibling) =>
              sibling.matches('.matrix-standalone-active-ques' + question.group_no),
            );

          const filteredElementsMSAQ = nextElementsMSAQ.filter(
            (el) => el.querySelector('.question-data') !== null,
          );

          // Get the position of the first matching element
          const firstMatchingElement = filteredElementsMSAQ[0];
          if (firstMatchingElement) {
            elemPosition = firstMatchingElement.getBoundingClientRect().top;
          }
        }
        // Adjust elemPosition based on preview settings
        if (checkIfPreview && checkIfPreview != '') {
          if (this.service.preview.viewport === 'web') {
            elemPosition =
              elemPosition -
              scrollTargetElement.getBoundingClientRect().top +
              scrollTargetElement.scrollTop -
              (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
          } else {
            scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
            elemPosition =
              elemPosition -
              scrollTargetElement.getBoundingClientRect().top +
              scrollTargetElement.scrollTop;
          }
        } else {
          elemPosition =
            elemPosition -
            scrollTargetElement.getBoundingClientRect().top +
            scrollTargetElement.scrollTop;
        }
        scrollTargetElement.scrollTo({
          top: elemPosition - window.innerHeight / 3,
          behavior: 'smooth',
        });
      } else if (this.questions.isMatrixQuestion != undefined && MatrixelemPosition !== null) {
        let matrixCurrentElementMtrxELe = event.closest(
          '.matrix-mobile-subQ_' + this.group.Matrix_id,
        ) as HTMLElement;
        if (matrixCurrentElementMtrxELe) {
          // Get all sibling elements after the current element
          const allSiblingsMtrxEle = Array.from(
            matrixCurrentElementMtrxELe.parentElement?.children || [],
          ) as HTMLElement[];
          const nextMatrixElementsMtrxEle = allSiblingsMtrxEle
            .slice(allSiblingsMtrxEle.indexOf(matrixCurrentElementMtrxELe) + 1)
            .filter(
              (sibling) =>
                sibling.matches('.matrix-mobile-subQ_' + this.group.Matrix_id) &&
                sibling.querySelector('.question-data') !== null,
            ); // Filter by selector and `.question-data`

          // Get the position of the first matching element
          if (nextMatrixElementsMtrxEle.length > 0) {
            MatrixelemPosition = nextMatrixElementsMtrxEle[0].getBoundingClientRect().top;
          }
        }

        if (checkIfPreview && checkIfPreview != '') {
          if (this.service.preview.viewport === 'web') {
            MatrixelemPosition =
              MatrixelemPosition -
              scrollTargetElement.getBoundingClientRect().top +
              scrollTargetElement.scrollTop -
              (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
          } else {
            scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
            MatrixelemPosition =
              MatrixelemPosition -
              scrollTargetElement.getBoundingClientRect().top +
              scrollTargetElement.scrollTop;
          }
        } else {
          MatrixelemPosition =
            MatrixelemPosition -
            scrollTargetElement.getBoundingClientRect().top +
            scrollTargetElement.scrollTop;
        }

        scrollTargetElement.scrollTo({
          top: MatrixelemPosition - window.innerHeight / 3,
          behavior: 'smooth',
        });
      } else if (this.questions.isMatrixQuestion != undefined && MatrixelemPosition1 !== null) {
        // Find the closest `.matrix-mobile-subQ-cont` element
        let matrixContCurrentElementM1 = event.closest('.matrix-mobile-subQ-cont') as HTMLElement;
        if (matrixContCurrentElementM1) {
          // Get all sibling elements after the current element
          const allSiblingsMtrxCOntM1 = Array.from(
            matrixContCurrentElementM1.parentElement?.children || [],
          ) as HTMLElement[];
          const nextMatrixContElementsM1 = allSiblingsMtrxCOntM1
            .slice(allSiblingsMtrxCOntM1.indexOf(matrixContCurrentElementM1) + 1) // Get all siblings after the current element
            .filter(
              (sibling) =>
                sibling.matches('.matrix-mobile-subQ-cont') &&
                sibling.querySelector('.question-data') !== null,
            ); // Filter by selector and `.question-data`

          // Get the position of the first matching element
          if (nextMatrixContElementsM1.length > 0) {
            MatrixelemPosition1 = nextMatrixContElementsM1[0].getBoundingClientRect().top;
          }
        }

        if (checkIfPreview && checkIfPreview != '') {
          if (this.service.preview.viewport === 'web') {
            MatrixelemPosition1 =
              MatrixelemPosition1 -
              scrollTargetElement.getBoundingClientRect().top +
              scrollTargetElement.scrollTop -
              (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
          } else {
            scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
            MatrixelemPosition1 =
              MatrixelemPosition1 -
              scrollTargetElement.getBoundingClientRect().top +
              scrollTargetElement.scrollTop;
          }
        } else {
          MatrixelemPosition1 =
            MatrixelemPosition1 -
            scrollTargetElement.getBoundingClientRect().top +
            scrollTargetElement.scrollTop;
        }
        scrollTargetElement.scrollTo({
          top: MatrixelemPosition1 - window.innerHeight / 3,
          behavior: 'smooth',
        });
      } else if (nextbtnLength > 0) {
        let activeQuestionForNBL = event.closest('.active-ques') as HTMLElement;

        if (activeQuestionForNBL) {
          // Get all sibling elements after the current element
          const allSiblingsForNBL = Array.from(
            activeQuestionForNBL.parentElement?.children || [],
          ) as HTMLElement[];
          const nextInactiveQuestionsForNBL = allSiblingsForNBL
            .slice(allSiblingsForNBL.indexOf(activeQuestionForNBL) + 1) // Get all siblings after the current element
            .filter(
              (sibling) =>
                sibling.matches('.inactive-ques') &&
                sibling.querySelector('.question-data') !== null,
            ); // Filter by selector and `.question-data`

          // Get the position of the first matching element
          if (nextInactiveQuestionsForNBL.length > 0) {
            elemPosition = nextInactiveQuestionsForNBL[0].getBoundingClientRect().top;
          }
        }

        if (checkIfPreview && checkIfPreview != '') {
          if (this.service.preview.viewport === 'web') {
            elemPosition =
              elemPosition -
              scrollTargetElement.getBoundingClientRect().top +
              scrollTargetElement.scrollTop -
              (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
          } else {
            scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
            elemPosition =
              elemPosition -
              scrollTargetElement.getBoundingClientRect().top +
              scrollTargetElement.scrollTop;
          }
        } else {
          elemPosition =
            elemPosition -
            scrollTargetElement.getBoundingClientRect().top +
            scrollTargetElement.scrollTop;
        }
        scrollTargetElement.scrollTo({
          top: elemPosition - window.innerHeight / 3,
          behavior: 'smooth', // Replaces jQuery's animate for smooth scrolling
        });
      } else {
        if (checkIfPreview && checkIfPreview != '') {
          if (this.service.preview.viewport === 'web') {
            scrollTargetElement = document.getElementById('bodyScroll') as HTMLElement;
          } else {
            scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
          }
        }
        const tblPageFooter = document.querySelector('.tblPageFooter') as HTMLElement;
        if (tblPageFooter && scrollTargetElement) {
          const scrollVal =
            tblPageFooter.getBoundingClientRect().top + scrollTargetElement.scrollTop;

          scrollTargetElement.scrollTo({
            top: scrollVal,
            behavior: 'smooth',
          });
        }
      }
    } else {
      this.service.gotoNextQuestion(question, event);
    }
  }

  checkboxSelection(answer: Answers) {
    if (answer.selectdId == 0) {
      this.SelectedValue(answer, true);
    } else {
      this.SelectedValue(answer, false);
    }
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event);
  }

  getAnswerPipeMessage(): string {
    return this.service.getAnswerPipeMessage();
  }

  CheckInSelectedAnsertList(value_id: any): boolean {
    if (
      this.questions.selectedOptionList &&
      this.questions.selectedOptionList.find((e) => e.value_id == value_id) != undefined
    ) {
      return true;
    } else {
      return false;
    }
  }
}
